import gql from 'graphql-tag'

export default gql`query projectSupplierInvoice($project_id: String!){
  projectSupplierInvoice: project(project_id: $project_id){
    project_id
    name
    project_activity_budgets{
      project_activity_budget_id: id
      project_activity_type{
        description
      }
      description
      stage
      amount_to_invoice
      budget_label
    }
    
  }

}`